export type UpsellId = 'braveMind' | 'littleEngineer' | 'focusLab'

export type Upsell = {
  id: UpsellId
  title: string
  price: number
  compareAt?: number
  description: string
  thumbLabel: string
  image?: string
  starterOnly?: boolean
}

export const upsells: Upsell[] = [
  {
    id: 'braveMind',
    title: 'Brave Mind — Personalized Meditations for Your Child',
    price: 89,
    compareAt: 149,
    description:
      "The one thing on this page you don't have to make. Five meditations recorded around your child's name and what they're struggling with — delivered in 5 business days.",
    thumbLabel: 'BRAVE MIND COVER',
    image:
      'https://cdn.magicpatterns.com/uploads/e6NFG18VYSR3p5Np8Vvt4M/cbbfdb54-0ee8-47f0-bc07-e7b31f61ebe9.webp',
  },
  {
    id: 'littleEngineer',
    title: 'Little Engineer Mega Kit',
    price: 27.99,
    compareAt: 37.99,
    description:
      '365 screen-free projects for boys and girls ages 4-10. What they DO once the routine is running.',
    thumbLabel: 'LITTLE ENGINEER COVER',
    image:
      'https://cdn.magicpatterns.com/uploads/5DiFMccceBpXjVNU6wNYvR/43fc4fc1-e22f-4b85-9432-b5f31209ed00.webp',
  },
  {
    id: 'focusLab',
    title: 'NeuroKids Focus System',
    price: 19.99,
    compareAt: 29.99,
    description:
      '100+ printable brain-training exercises. One page a day, ten minutes, no screen.',
    thumbLabel: 'NEUROKIDS COVER',
    image:
      'https://cdn.magicpatterns.com/uploads/kwk39hcMG7UmMA2WSjmMB6/eb637896-f724-488b-ad28-2b023dbab033.webp',
  },
]

export function formatPrice(value: number): string {
  return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`
}
